// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Target the specific section */
.clientForm_custom-scrollbar__6te8B::-webkit-scrollbar {
    width: 1px; /* Adjust scrollbar width */
    height: 5px;
  }
  
  .clientForm_custom-scrollbar__6te8B::-webkit-scrollbar-track {
    background: var(--disabled-color); /* Track background color */
  }
  
  .clientForm_custom-scrollbar__6te8B::-webkit-scrollbar-thumb {
    background-color: var(--light-primary-color); /* Thumb color */
    border-radius: 10px; /* Optional: Rounded corners */
  }
  
  .clientForm_custom-scrollbar__6te8B::-webkit-scrollbar-thumb:hover {
    background: var(--para-color); /* Thumb hover effect */
  }
  
  .clientForm_clientModalColor__nznCy {
    background-color: var(--showModalBackground-color);
  }
  
  
  .clientForm_tableRow__1hFq3{
    padding: 0px 4px !important;
     border-left: 1px solid #efecec !important;
    border-right: 1px solid #efecec !important;
  }
  
  .clientForm_formstyling__C\\+YRI {
    background: white;
    padding: 3.5rem 1.5rem;
    border-radius: 0.7rem;
    border: 1px solid gray;
    margin: 1rem 0;
  }
  
  .clientForm_clientHeading__aE-kS {
    font-size: 1.5rem !important;
    font-weight: 700 !important;
    line-height: 1.75rem !important;
  }
  
  .clientForm_vendorSection__Gy8Y2 {
    min-height: 24vh;
  }
  
  .clientForm_vendorSectionImg__WoUGm {
    border: 1px solid gray;
    border-radius: 0.3 rem;
    padding: 2px;
  }
  
  .clientForm_vendorSectionError__bKTO3 {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 25vh;
  }
  
  .clientForm_bg-blue-100__D6zFe {
    background-color: #ebf8ff;
  }
  
  .clientForm_bg-green-100__wUUin {
    background-color: #f0fff4;
  }
  
  .clientForm_bg-yellow-100__SJcXz {
    background-color: #fffbeb;
  }
  
  .clientForm_labelColor__5oeKM {
    color: #36383A !important;
  }
  
  .clientForm_labelErrorColor__aRLIj {
    color: #ff5555 !important;
  }
  
  .clientForm_noPaddingTop__moH3S {
    padding-top: 0px !important;
  }
  
  .clientForm_custom1-scrollbar__aThIe::-webkit-scrollbar {
    width: 5px; /* Adjust scrollbar width */
  }
  
  .clientForm_custom1-scrollbar__aThIe::-webkit-scrollbar-track {
    background: var(--disabled-color); /* Track background color */
    
  }
  
  .clientForm_custom1-scrollbar__aThIe::-webkit-scrollbar-thumb {
    background-color: var(--para-color); /* Thumb color */
    border-radius: 10px; /* Optional: Rounded corners */
    
  }
  
  .clientForm_custom1-scrollbar__aThIe::-webkit-scrollbar-thumb:hover {
    background: var(--para-color); /* Thumb hover effect */
  }`, "",{"version":3,"sources":["webpack://./src/styles/clientForm.module.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;IACI,UAAU,EAAE,2BAA2B;IACvC,WAAW;EACb;;EAEA;IACE,iCAAiC,EAAE,2BAA2B;EAChE;;EAEA;IACE,4CAA4C,EAAE,gBAAgB;IAC9D,mBAAmB,EAAE,8BAA8B;EACrD;;EAEA;IACE,6BAA6B,EAAE,uBAAuB;EACxD;;EAEA;IACE,kDAAkD;EACpD;;;EAGA;IACE,2BAA2B;KAC1B,yCAAyC;IAC1C,0CAA0C;EAC5C;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;IAC3B,+BAA+B;EACjC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,UAAU,EAAE,2BAA2B;EACzC;;EAEA;IACE,iCAAiC,EAAE,2BAA2B;;EAEhE;;EAEA;IACE,mCAAmC,EAAE,gBAAgB;IACrD,mBAAmB,EAAE,8BAA8B;;EAErD;;EAEA;IACE,6BAA6B,EAAE,uBAAuB;EACxD","sourcesContent":["/* Target the specific section */\n.custom-scrollbar::-webkit-scrollbar {\n    width: 1px; /* Adjust scrollbar width */\n    height: 5px;\n  }\n  \n  .custom-scrollbar::-webkit-scrollbar-track {\n    background: var(--disabled-color); /* Track background color */\n  }\n  \n  .custom-scrollbar::-webkit-scrollbar-thumb {\n    background-color: var(--light-primary-color); /* Thumb color */\n    border-radius: 10px; /* Optional: Rounded corners */\n  }\n  \n  .custom-scrollbar::-webkit-scrollbar-thumb:hover {\n    background: var(--para-color); /* Thumb hover effect */\n  }\n  \n  .clientModalColor {\n    background-color: var(--showModalBackground-color);\n  }\n  \n  \n  .tableRow{\n    padding: 0px 4px !important;\n     border-left: 1px solid #efecec !important;\n    border-right: 1px solid #efecec !important;\n  }\n  \n  .formstyling {\n    background: white;\n    padding: 3.5rem 1.5rem;\n    border-radius: 0.7rem;\n    border: 1px solid gray;\n    margin: 1rem 0;\n  }\n  \n  .clientHeading {\n    font-size: 1.5rem !important;\n    font-weight: 700 !important;\n    line-height: 1.75rem !important;\n  }\n  \n  .vendorSection {\n    min-height: 24vh;\n  }\n  \n  .vendorSectionImg {\n    border: 1px solid gray;\n    border-radius: 0.3 rem;\n    padding: 2px;\n  }\n  \n  .vendorSectionError {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 25vh;\n  }\n  \n  .bg-blue-100 {\n    background-color: #ebf8ff;\n  }\n  \n  .bg-green-100 {\n    background-color: #f0fff4;\n  }\n  \n  .bg-yellow-100 {\n    background-color: #fffbeb;\n  }\n  \n  .labelColor {\n    color: #36383A !important;\n  }\n  \n  .labelErrorColor {\n    color: #ff5555 !important;\n  }\n  \n  .noPaddingTop {\n    padding-top: 0px !important;\n  }\n  \n  .custom1-scrollbar::-webkit-scrollbar {\n    width: 5px; /* Adjust scrollbar width */\n  }\n  \n  .custom1-scrollbar::-webkit-scrollbar-track {\n    background: var(--disabled-color); /* Track background color */\n    \n  }\n  \n  .custom1-scrollbar::-webkit-scrollbar-thumb {\n    background-color: var(--para-color); /* Thumb color */\n    border-radius: 10px; /* Optional: Rounded corners */\n    \n  }\n  \n  .custom1-scrollbar::-webkit-scrollbar-thumb:hover {\n    background: var(--para-color); /* Thumb hover effect */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"custom-scrollbar": `clientForm_custom-scrollbar__6te8B`,
	"clientModalColor": `clientForm_clientModalColor__nznCy`,
	"tableRow": `clientForm_tableRow__1hFq3`,
	"formstyling": `clientForm_formstyling__C+YRI`,
	"clientHeading": `clientForm_clientHeading__aE-kS`,
	"vendorSection": `clientForm_vendorSection__Gy8Y2`,
	"vendorSectionImg": `clientForm_vendorSectionImg__WoUGm`,
	"vendorSectionError": `clientForm_vendorSectionError__bKTO3`,
	"bg-blue-100": `clientForm_bg-blue-100__D6zFe`,
	"bg-green-100": `clientForm_bg-green-100__wUUin`,
	"bg-yellow-100": `clientForm_bg-yellow-100__SJcXz`,
	"labelColor": `clientForm_labelColor__5oeKM`,
	"labelErrorColor": `clientForm_labelErrorColor__aRLIj`,
	"noPaddingTop": `clientForm_noPaddingTop__moH3S`,
	"custom1-scrollbar": `clientForm_custom1-scrollbar__aThIe`
};
export default ___CSS_LOADER_EXPORT___;
